import MainLayout from '../layout/MainLayout/MainLayout'
import NavLocation from '../layout/NavLocation/NavLocation'
import '../components/display/display.css'
import './PlaceholderPage.css'

// Empty landing page. Same sidebar-and-main shell as the working pages, with
// nothing in either pane yet.
function PlaceholderPage({ title, storageId }) {
  return (
    <MainLayout
      storageId={storageId}
      navLocation={<NavLocation title={title} />}
      nav={
        <div className="placeholder-fill">
          <div className="display-empty">Coming soon.</div>
        </div>
      }
      display={<div className="display-empty">Coming soon.</div>}
    />
  )
}

export default PlaceholderPage
